import buildFunStuffPictureObj from "../../../pages/Objects/build_fun_stuff_picture_obj";

export const resetPicturesForChanges = (changeReason, pictureInfo, newID, newName, newImg, 
        newSecondaryImg, funStuffInfo, pendingJobPictureInfo) => {

   
    let newPictureInfo = JSON.parse(JSON.stringify(pictureInfo));
    switch(changeReason) {
        case "career":
            newPictureInfo.jobID = newID;
            newPictureInfo.jobImg = newImg;
            newPictureInfo.jobName = newName;
            newPictureInfo.jobBackground = newSecondaryImg;
            if (pendingJobPictureInfo){
                newPictureInfo.jobMaxSalary = pendingJobPictureInfo.jobMaxSalary;
                newPictureInfo.jobLevel2 = pendingJobPictureInfo.jobLevel2;
                newPictureInfo.jobLevel3 = pendingJobPictureInfo.jobLevel3;
            }else{
                newPictureInfo.jobMaxSalary = pictureInfo.jobMaxSalary;
                newPictureInfo.jobLevel2 = pictureInfo.jobLevel2;
                newPictureInfo.jobLevel3 = pictureInfo.jobLevel3;
            }
            break;
        case "home":
            newPictureInfo.homeID = newID;
            newPictureInfo.homeImg = newImg;
            newPictureInfo.homeName = newName;
            newPictureInfo.livingRoomImg = newSecondaryImg;
            break;
        case "car":
            newPictureInfo.carID = newID;
            newPictureInfo.carImg = newImg;
            newPictureInfo.carName = newName;
            break;
        case "funStuff":
            let newFunStuffPictureObj = {funstuffInfo: false};
            if (funStuffInfo.gameID ){
                const funStuffPictureDir = buildFunStuffPictureObj(funStuffInfo);
                newFunStuffPictureObj = {...funStuffPictureDir, funStuffExists: true};
            }
            newPictureInfo.funStuffInfo = newFunStuffPictureObj;
            break;
        default:
            break;
        }
 

    return newPictureInfo;
   
}





